"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _AVA = _interopRequireDefault(require("./AVA.proptypes"));

var _AVA2 = _interopRequireDefault(require("./AVA.util"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var AVAContainer = _styledComponents.default.div.withConfig({
  displayName: "AVAChatbot__AVAContainer",
  componentId: "sc-wr5nvu-0"
})(["visibility:", ";"], function (_ref) {
  var visible = _ref.visible;
  return visible ? 'visible' : 'hidden';
});

var AVAIcon = _styledComponents.default.div.withConfig({
  displayName: "AVAChatbot__AVAIcon",
  componentId: "sc-wr5nvu-1"
})(function (_ref2) {
  var avaPositionConfig = _ref2.avaPositionConfig;
  return "\n    position: fixed;\n    cursor: pointer;\n    z-index: 10;\n    top: ".concat(avaPositionConfig.top, ";\n    right: ").concat(avaPositionConfig.right, ";\n    bottom: ").concat(avaPositionConfig.bottom, ";\n    left: ").concat(avaPositionConfig.left, ";\n  ");
});

var AVATooltip = _styledComponents.default.div.withConfig({
  displayName: "AVAChatbot__AVATooltip",
  componentId: "sc-wr5nvu-2"
})(["display:none;position:absolute;right:116%;top:24%;min-width:140px;text-align:center;border-radius:", ";background-color:", ";box-shadow:0 0 8px 2px rgba(0,0,0,0.2),0 0 8px 2px rgba(0,0,0,0.19);padding:", ";", ":hover &{display:inline-block;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.backgroundColor.default;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.micro;
}, AVAIcon);

var Overlay = _styledComponents.default.div.withConfig({
  displayName: "AVAChatbot__Overlay",
  componentId: "sc-wr5nvu-3"
})(["position:fixed;top:0;bottom:0;left:0;right:0;z-index:-1;background-color:", ";opacity:0;transition:ease-out 0.3s;&.open{z-index:17;opacity:0.5;", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyDarker;
}, function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile && (0, _styledComponents.css)(["z-index:", ";"], function (_ref8) {
    var zIndex = _ref8.zIndex;
    return zIndex;
  });
});

var AVAFrame = _styledComponents.default.div.withConfig({
  displayName: "AVAChatbot__AVAFrame",
  componentId: "sc-wr5nvu-4"
})(["position:fixed;top:0;bottom:0;right:-100%;width:35vw;min-width:450px;z-index:18;overflow:auto;background-color:", ";transition:0.3s ease-out;", ";&.open{right:0;}& .ada-embed-app{position:relative;z-index:1;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.default;
}, function (_ref10) {
  var isMobile = _ref10.isMobile;
  return isMobile && (0, _styledComponents.css)(["min-width:unset;width:100%;z-index:", ";"], function (_ref11) {
    var zIndex = _ref11.zIndex;
    return zIndex + 1;
  });
});

var AVACloseBtn = _styledComponents.default.div.withConfig({
  displayName: "AVAChatbot__AVACloseBtn",
  componentId: "sc-wr5nvu-5"
})(["position:absolute;right:", ";top:", ";cursor:pointer;z-index:2;"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.small;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.space.large;
});

var AVAChatbot = function AVAChatbot(props) {
  var env = props.env,
      language = props.language,
      isLogin = props.isLogin,
      enableLogin = props.enableLogin,
      openAvaOnLogin = props.openAvaOnLogin,
      ssoLoginData = props.ssoLoginData,
      lemonUserData = props.lemonUserData,
      dataConfig = props.dataConfig,
      imageConfig = props.imageConfig,
      adaEmbedConfig = props.adaEmbedConfig,
      customProperties = props.customProperties,
      accessible = props.accessible,
      theme = props.theme,
      gtmEventData = props.gtmEventData,
      fireGtm = props.fireGtm,
      isMobile = props.isMobile,
      avaPositionConfig = props.avaPositionConfig,
      sourceV2 = props.sourceV2;

  var aggregatedAvaPositionConfig = _objectSpread(_objectSpread({}, _AVA.default.DefaultProps.avaPositionConfig), avaPositionConfig);

  var aggregatedImageConfig = _objectSpread(_objectSpread({}, _AVA.default.DefaultProps.imageConfig), imageConfig);

  var tooltipLabel = dataConfig.tooltipLabel,
      productionID = dataConfig.productionID,
      stagingID = dataConfig.stagingID;
  var imageURL = aggregatedImageConfig.imageURL,
      width = aggregatedImageConfig.width,
      height = aggregatedImageConfig.height,
      radius = aggregatedImageConfig.radius;
  var handle = adaEmbedConfig.handle,
      parentElement = adaEmbedConfig.parentElement,
      metaFields = adaEmbedConfig.metaFields,
      lang = adaEmbedConfig.lang; // eslint-disable-next-line camelcase

  var sso_user_data = metaFields.sso_user_data,
      platform = metaFields.platform,
      source = metaFields.source;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isAVAOpen = _useState2[0],
      setIsAVAOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      cipherText = _useState4[0],
      setCipherText = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      lemonUserCipherText = _useState6[0],
      setLemonUserCipherText = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      isUserDataLoaded = _useState8[0],
      setUserDataLoaded = _useState8[1];

  var _useState9 = (0, _react.useState)(17),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      zIndex = _useState10[0],
      setZIndex = _useState10[1];

  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getShortLang = function getShortLang(longLang) {
    var res = longLang ? longLang.split('-')[0] : 'en';
    return res.toLowerCase();
  };

  var shortLang = getShortLang(language);

  var addAvaScript = function addAvaScript() {
    var sourceURL = sourceV2 ? _constant.AVA_SCRIPT.SOURCE2 : _constant.AVA_SCRIPT.SOURCE; // eslint-disable-next-line no-new

    return new Promise(function (resolve) {
      var tag = document.createElement('script');
      tag.setAttribute('async', '');
      tag.setAttribute('data-lazy', '');
      tag.setAttribute('id', _constant.AVA_SCRIPT.ID);
      tag.src = sourceURL;
      document.body.appendChild(tag);

      tag.onload = function () {
        resolve();
      };
    });
  };

  var getEnvID = function getEnvID(environment) {
    if (environment.toLowerCase() === 'prod' || environment.toLowerCase() === 'preprod') {
      return productionID;
    }

    return stagingID;
  };

  var getCipherText = /*#__PURE__*/function () {
    var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(payload) {
      var data, headersValue, res;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              data = {
                methodName: 'encrypt',
                payload: JSON.stringify(payload)
              };
              headersValue = {
                'Content-Type': 'application/json'
              };
              _context.next = 5;
              return _AVA2.default.post(_constant.AVA_DEFAULTS.URLS.ENCRYPTION_URL, headersValue, data);

            case 5:
              res = _context.sent;
              return _context.abrupt("return", res.ciphertext);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", null);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function getCipherText(_x) {
      return _ref14.apply(this, arguments);
    };
  }();

  var getSSOCipher = /*#__PURE__*/function () {
    var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(ssoLogData) {
      var ssoData, tokenRequest, key, avaPostData, ssoCipherText;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!ssoLogData || !ssoLogData.ssoData)) {
                _context2.next = 3;
                break;
              }

              setCipherText(null);
              return _context2.abrupt("return");

            case 3:
              ssoData = ssoLogData.ssoData;
              tokenRequest = localStorage !== 'undefined' ? JSON.parse(localStorage.getItem('aa_tokens')) : null;
              key = sessionStorage !== 'undefined' ? sessionStorage.getItem(_constant.AVA_DEFAULTS.API_KEY) : null;
              avaPostData = {
                firstName: ssoData.firstName,
                lastName: ssoData.lastName,
                username: ssoData.username,
                dateOfBirth: ssoData.dateOfBirth,
                ssoClientId: ssoData.clientId,
                ssoApiKey: key
              };

              if (tokenRequest) {
                avaPostData = _objectSpread(_objectSpread({}, avaPostData), {}, {
                  userId: tokenRequest.userId ? tokenRequest.userId : '',
                  ssoRefreshToken: tokenRequest.refreshToken ? tokenRequest.refreshToken : '',
                  ssoAccessToken: tokenRequest.accessToken ? tokenRequest.accessToken : ''
                });
              }

              _context2.next = 10;
              return getCipherText(avaPostData);

            case 10:
              ssoCipherText = _context2.sent;
              setCipherText(ssoCipherText);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getSSOCipher(_x2) {
      return _ref15.apply(this, arguments);
    };
  }();

  var getSignOrigin = function getSignOrigin() {
    var ssoURL = env.toLowerCase() === _constant.AVA_DEFAULTS.ENV ? _constant.AVA_DEFAULTS.URLS.SSO.PROD : _constant.AVA_DEFAULTS.URLS.SSO.OTHERS;
    var byOriginURL = "".concat(ssoURL).concat(_constant.AVA_DEFAULTS.URLS.BY_ORIGIN);
    var headerValue = {
      'Content-Type': 'application/json'
    };

    _AVA2.default.get(byOriginURL, headerValue).then(function (res) {
      if (!res) {
        return;
      }

      var key = null;

      if (typeof sessionStorage !== 'undefined') {
        key = sessionStorage.getItem(_constant.AVA_DEFAULTS.CLIENT_ID_KEY) || null;
        sessionStorage.setItem(_constant.AVA_DEFAULTS.API_KEY, JSON.stringify(res.apiKey));
        sessionStorage.setItem(_constant.AVA_DEFAULTS.CLIENT_ID_KEY, JSON.stringify(res.id));
      }

      if (!key) {
        getSSOCipher(ssoLoginData);
      }
    });
  };

  var closeAVAFrameHandler = function closeAVAFrameHandler(clear) {
    setIsAVAOpen(false);

    if (typeof document !== 'undefined') {
      var bodyElement = document.getElementsByTagName('body');

      if (bodyElement) {
        bodyElement[0].style.removeProperty('overflow');
      }
    }

    if (typeof window !== 'undefined' && window.adaEmbed) {
      try {
        window.adaEmbed.stop();
      } catch (_unused2) {// Do nothing
      }
    }

    if (enableLogin && typeof sessionStorage !== 'undefined' && clear && !isLogin) {
      sessionStorage.setItem(_constant.AVA_DEFAULTS.IS_AVA_OPEN, false);
    }
  };

  var iframeListener = function iframeListener() {
    _utilities.default.elementReady('#ada-embed > iframe').then(function (el) {
      var element = el; // Hack to override ava plugin giving left: -10000px that causes chatbot to be hidden

      setTimeout(function () {
        element.style = 'left: 0!important';
      }, 1000);
    });
  };

  function onClickAVAHandler() {
    return _onClickAVAHandler.apply(this, arguments);
  }

  function _onClickAVAHandler() {
    _onClickAVAHandler = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var bodyElement, avaEnvID, evt;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return addAvaScript();

            case 2:
              setIsAVAOpen(true);

              if (typeof document !== 'undefined') {
                bodyElement = document.getElementsByTagName('body');

                if (bodyElement) {
                  bodyElement[0].style.overflow = 'hidden';
                }
              }

              if (typeof window !== 'undefined') {
                iframeListener();
                avaEnvID = getEnvID(env);
                window.adaEmbed.start({
                  handle: handle || avaEnvID,
                  parentElement: parentElement,
                  metaFields: {
                    // eslint-disable-next-line camelcase
                    sso_user_data: sso_user_data || cipherText,
                    platform: platform,
                    source: source,
                    lemon_user_data: lemonUserCipherText
                  },
                  language: lang || shortLang
                });
              }

              if (fireGtm && gtmEventData) {
                fireGtm("".concat(gtmEventData), true);
              }

              if (enableLogin && !isLogin) {
                if (typeof sessionStorage !== 'undefined') {
                  sessionStorage.setItem(_constant.AVA_DEFAULTS.IS_AVA_OPEN, true);
                }

                if (isMobile) setZIndex(9);
                evt = new CustomEvent('openLogin', {
                  detail: true
                });
                window.dispatchEvent(evt);
              }

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _onClickAVAHandler.apply(this, arguments);
  }

  var changeZIndex = function changeZIndex() {
    setZIndex(17);
  };

  var removeCookie = function removeCookie() {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(_constant.AVA_DEFAULTS.IS_AVA_OPEN);
    }
  };

  var getLemonCipher = /*#__PURE__*/function () {
    var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var lemonCipherText;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getCipherText(lemonUserData);

            case 2:
              lemonCipherText = _context3.sent;
              setLemonUserCipherText(lemonCipherText);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function getLemonCipher() {
      return _ref16.apply(this, arguments);
    };
  }(); // ComponentDidMount


  (0, _react.useEffect)(function () {
    // Remove overflow hidden and stop AVA on component unmount
    return function () {
      return closeAVAFrameHandler(false);
    };
  }, []);
  (0, _react.useEffect)(function () {
    getSignOrigin();
  }, [env]);
  (0, _react.useEffect)(function () {
    var key = sessionStorage !== 'undefined' ? sessionStorage.getItem(_constant.AVA_DEFAULTS.API_KEY) : null;
    if (key) getSSOCipher(ssoLoginData);
  }, [ssoLoginData]);
  (0, _react.useEffect)(function () {
    if (lemonUserData) {
      getLemonCipher();
    }
  }, [lemonUserData]);
  (0, _react.useEffect)(function () {
    if (cipherText && isLogin && window && window.adaEmbed !== 'undefined') {
      setUserDataLoaded(true);
      var isOpen = sessionStorage !== 'undefined' ? sessionStorage.getItem(_constant.AVA_DEFAULTS.IS_AVA_OPEN) : null;

      if (isOpen === 'true' && openAvaOnLogin && enableLogin) {
        onClickAVAHandler();
      }

      removeCookie();
    }
  }, [cipherText]);
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('loginModalClose', changeZIndex);
    }

    return function () {
      return typeof window !== 'undefined' ? window.removeEventListener('loginModalClose', changeZIndex) : null;
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('loginClicked', removeCookie);
    }

    return function () {
      return typeof window !== 'undefined' ? window.removeEventListener('loginClicked', removeCookie) : null;
    };
  }, []);

  var avaFrame = function avaFrame() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Overlay, {
      onClick: function onClick() {
        return closeAVAFrameHandler(true);
      },
      className: isAVAOpen && 'open',
      isMobile: isMobile,
      zIndex: zIndex
    }), /*#__PURE__*/_react.default.createElement(AVAFrame, {
      id: parentElement,
      className: isAVAOpen && 'open',
      isMobile: isMobile,
      zIndex: zIndex
    }, /*#__PURE__*/_react.default.createElement(AVACloseBtn, {
      onClick: function onClick() {
        return closeAVAFrameHandler(true);
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      fontsize: "titleNormal",
      icon: "CloseIcon",
      accessible: accessible,
      theme: theme
    }))));
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(AVAContainer, (0, _extends2.default)({
      id: "airasia-ava",
      tabIndex: tabIndex,
      visible: isLogin != null && !isLogin || isUserDataLoaded
    }, customProperties), /*#__PURE__*/_react.default.createElement(AVAIcon, {
      id: "airasia-ava-icon",
      onClick: onClickAVAHandler,
      avaPositionConfig: aggregatedAvaPositionConfig
    }, tooltipLabel && /*#__PURE__*/_react.default.createElement(AVATooltip, {
      id: "ava-tooltip"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme
    }, tooltipLabel)), /*#__PURE__*/_react.default.createElement(_Image.default, {
      accessible: accessible,
      height: height,
      radius: radius,
      src: imageURL,
      theme: theme,
      width: width,
      alt: "AVA Icon"
    })), avaFrame());
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

AVAChatbot.propTypes = _AVA.default.PropTypes;
AVAChatbot.defaultProps = _AVA.default.DefaultProps;
var _default = AVAChatbot;
exports.default = _default;